import React from "react";
import { ICheckbox } from "../../../interfaces/globalComponents/checkbox/ICheckbox";
import { Checkbox as MaterialCheckbox } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";

export const Checkbox = ({ checked }: ICheckbox) => {
  const componentColors = useSelector(
    (state: RootState) => state.theme.componentColors
  );

  return (
    <MaterialCheckbox
      checked={checked}
      sx={{
        "&.Mui-checked": {
          color: componentColors.primary.primary,
        },
      }}
    />
  );
};
